<template>
	<div class="feature-icons">
    <div class="feature-icons__centraliser page-container">
    	<div class="grid">
	      <div class="grid__item feature-icons__item one-third--desk one-half--ltab" v-for="(item, index) in itemIcons" :key="index">
	        <div class="feature-icons__icon"></div>
	        <div class="h4 feature-icons__heading">{{ item.title }}</div>
	        <p
	          class="feature-icons__text"
	        >{{ item.content }}</p>
	      </div>
	    </div>
    </div>
  </div>
</template>

<script>

export default {

  props: {
    itemIcons: Array
  },
  mounted() {
  }
};
</script>

<style lang="scss">

	@import "src/scss/toolkit";

	$c: ".feature-icons";
	#{$c} {
	  padding-top: rem(128);
	  padding-bottom: rem(128);
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  padding-right: 20px;
	  padding-left: 20px;

	  &__icon {
	    width: rem(48);
	    height: rem(48);
	    background-color: #44997a;
	    border-radius: rem(8);
	    margin-bottom: rem(36);

	    @include media(phab)
	    {
	    	margin-bottom: rem(16);
	    }

	    #{$c}__item:nth-child(6n+1) & { background-color: #76BBC8; }
	    #{$c}__item:nth-child(6n+2) & { background-color: #44997A; }
	    #{$c}__item:nth-child(6n+3) & { background-color: #5F5490; }
	    #{$c}__item:nth-child(6n+4) & { background-color: #D16455; }
	    #{$c}__item:nth-child(6n+5) & { background-color: #76A9C4; }
	    #{$c}__item:nth-child(6n+6) & { background-color: #76BBC8; }
	  }

	  &__heading {
	  }

	  &__text {
	    color: palette(grey);
	    line-height: 2;
	  }
	}
</style>



// WEBPACK FOOTER //
// src/components/organisms/FeatureIcons.vue